<template>
  <!-- 新建活动 -->
  <el-dialog class="dialog-add-activity" :title="pageType === 'add' ? '新建活动' : '编辑活动'" @close="cancel"
    :visible.sync="dialogVisible" width="1200px">
    <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="16">
          <el-col :span="24">
            <el-form-item label="活动类型 :" prop="type">
              <el-select v-model="form.type" filterable @change="changeActivity" placeholder="请选择"
                :disabled="pageType === 'detail'">
                <el-option v-for="item in typeList" :key="item.dictCode" :label="item.dictName"
                  :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="selectVal == '4'" :span="24">
            <el-form-item label="二级分类 :" prop="twoLevelType">
              <el-select v-model="form.twoLevelType" filterable placeholder="请选择二级分类" :disabled="pageType === 'detail'">
                <el-option v-for="item in serviceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="活动名称 :" prop="activityName">
              <el-input v-model="form.activityName" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>


          <el-col v-if="selectVal != 3" :span="24">
            <el-form-item label="活动时间 :" prop="activityTime">
              <el-date-picker :disabled="pageType === 'detail'" v-model="form.activityTime"
                format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" type="datetime"
                placeholder="选择日期时间"></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col v-else :span="24">
            <el-form-item label="活动时间 :" prop="activityTime1">
              <el-date-picker v-model="littleTime" placeholder="选择日期时间" type="datetimerange" format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="发布时间 :" prop="createDate">
              <el-date-picker :disabled="pageType === 'detail'" v-model="form.createDate"
                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                placeholder="选择发布时间"></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="活动地点 :" prop="activityAddr">
              <el-input v-model="form.activityAddr" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="名额 :" :prop="selectVal == 4 ? 'quota1' : 'quota'">
              <el-input type="number" v-model.number="form.quota" placeholder="请输入"
                :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="24">
            <el-form-item label="报名限制 :" prop="repeatSet">
              <el-select v-model="form.repeatSet" filterable placeholder="请选择" :disabled="pageType === 'detail'">
                <el-option v-for="item in repeatList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->

          <el-col :span="24" v-if="selectVal != 4">
            <el-form-item label="年龄范围 :">
              <div style="display: flex">
                <el-select v-model="form.startAge" @change="startAgeChange" @clear="setStartAgeList" clearable
                  placeholder="请选择">
                  <el-option v-for="item in startAgeList" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
                <span style="display: inline-block;width:6%;text-align:center"> - </span>
                <el-select v-model="form.endAge" @change="endAgeChange" @clear="setEndAgeList" clearable
                  placeholder="请选择">
                  <el-option v-for="item in endAgeList" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="要求 :" prop="demand">
              <el-input v-model="form.demand" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="活动详情 :" prop="description">
              <cmp-ckeditor ref="myCkeditor" :defaultMsg="form.description" :id="`ue1`" :height="150"></cmp-ckeditor>
            </el-form-item>
          </el-col>
        </el-col>

        <el-col :span="8">
          <el-form-item class="avatar-uploader-form" label="活动封面 :" required>
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="false"
              accept=".jpg,.jpeg,.png,.JPG" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="imgUrl" style="height:120px;object-fit:cover;" :src="imgUrl" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传活动封面</div>
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="footer mt-30">
      <el-button @click="cancel">取消</el-button>
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import cmpUpload from '@cmp/my-upload/index' //上传组件
import cmpCkeditor from '@cmp/editor/ckeditor'
export default {
  components: { cmpUpload, cmpCkeditor },
  data() {
    const validateTime = (rule, value, callback) => {
      if (this.littleTime && this.littleTime.length <= 0 || !this.littleTime) {
        callback(new Error('活动时间不能为空'))
      } else {
        callback()
      }
    }
    return {
      loadingSave: false,
      pageType: '', // 页面类型 add 新增 edit 编辑 detail 查看
      detailId: '', // 详情id
      dialogVisible: false,
      form: {
        pictureId: '' // 封面id
      },
      imgUrl: '',
      configData: {
        tableName: 'collect'
      },
      serviceList: [{ id: '1', name: '赴农村' }, { id: '2', name: '进校园' }, { id: '3', name: '进企业' }, { id: '4', name: '进军营' }, { id: '5', name: '进机关' }, { id: '6', name: '进社区' }, { id: '7', name: '其他' }],
      startAgeList: [],
      endAgeList: [],
      littleTime: [],
      rules: {
        type: [{ required: true, message: '必填', trigger: 'change' }],
        activityName: [{ required: true, message: '必填', trigger: 'blur' }],
        activityTime: [{ required: true, message: '必填', trigger: 'blur' }],
        activityTime1: [{ required: true, validator: validateTime, trigger: 'blur' }],
        activityAddr: [{ required: true, message: '必填', trigger: 'blur' }],
        quota: [
          { required: true, message: '必填', trigger: 'blur' },
          {
            type: 'number',
            message: '名额必须为数字',
            trigger: 'blur',
            transform(value) {
              // 用于解决数字非必填函数。如果没有该函数，该字段会在表单提交时候进行触发（形成必填字段）
              return Number(value)
            }
          }
        ],
      },
      selectVal: '',
      remoteFileList: [],
      typeList: [],
      repeatList: [] // 报名限制
    }
  },
  methods: {
    init(type, detailId) {
      this.pageType = type // add 新增 edit 编辑 detail 查看
      this.detailId = detailId || ''
      this.form = {}

      this.setAgeList()
      this.$nextTick(() => {
        // this.$refs['form'].resetFields()
        this.$refs['form'].clearValidate()
        this.$refs.myCkeditor.initEditor()
      })

      this.dialogVisible = true
      if (this.detailId) {
        this.getDetail()
      }
      this.getSelect()
    },

    changeActivity(val) {
      let selected = this.typeList.filter(item => {
        return item.dictCode == val
      })

      if (selected && selected.length > 0) {
        this.selectVal = selected[0].dictCode
      }
      this.littleTime = []
    },

    startAgeChange(val) {
      this.endAgeList = this.endAgeList.filter(item => {
        return item > val
      })
    },

    endAgeChange(val) {
      this.startAgeList = this.startAgeList.filter(item => {
        return item < val
      })
    },

    setStartAgeList() {
      this.startAgeList = []
      if (this.form.endAge) {
        for (let m = 0; m < this.form.endAge; m++) {
          this.startAgeList.push(m)
        }
      }
    },
    setEndAgeList() {
      this.endAgeList = []
      if (this.form.startAge) {
        for (let m = this.form.startAge + 1; m < 100; m++) {
          this.endAgeList.push(m)
        }
      }
    },

    // 上传
    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 500
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 500MB!',
          type: 'warning'
        })
        return
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        this.form.pictureId = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },
    // 查询下拉框
    getSelect() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: ['activity_type', 'activity_repeatSet']
        })
        .then(res => {
          if (res.success) {
            var state = res.result
            // let firstArr = [{ dictCode: null, dictName: '全部' }]
            this.typeList = state['activity_type']
            this.repeatList = state['activity_repeatSet']
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 详情
    getDetail() {
      this.$http.get('/bsActivity/getDetail', {
        id: this.detailId
      }).then(res => {
        if (res.success) {
          let data = res.result
          this.form = data
          this.selectVal = data.type
          if (this.selectVal == 3) {
            let arr = [data.activityTime, data.activityTimeEnd]
            this.littleTime = arr
          }
          this.$nextTick(() => {
            this.imgUrl = data.pictureUrl
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 保存
    fromSubmit(form) {
      let content = this.$refs.myCkeditor.getContent() // 调用子组件方法
      if (this.selectVal != 4) {
        if (!this.form.pictureId) {
          this.$message.info('请上传活动封面')
          return
        }
      }
      if (!content) {
        this.$message.info('请输入内容')
        return
      }

      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          if (this.selectVal == 3) {
            if (this.littleTime && this.littleTime.length > 0) {
              this.form.activityTime = this.littleTime[0]
              this.form.activityTimeEnd = this.littleTime[1]
            }
          }

          this.$http.post('bsActivity/saveActivity', {
            ...this.form,
            description: content
          })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                if (this.pageType === 'add') {
                  this.$message.success('新建活动成功')
                } else {
                  this.$message.success('编辑活动成功')
                }
                this.dialogVisible = false
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },

    setAgeList() {
      this.startAgeList = []
      this.endAgeList = []
      for (let m = 0; m < 100; m++) {
        this.startAgeList.push(m)
        this.endAgeList.push(m)
      }
    },

    // 取消
    cancel() {
      this.$refs['form'].resetFields()
      this.selectVal = ""
      // this.form.startTime = ""
      // this.form.endTime = ""
      this.littleTime = []
      this.imgUrl = ""
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-add-staff {
  /deep/ .el-form-item__error {
    left: 0;
  }
}

/deep/ .el-date-editor {
  width: 100%;
}

.avatar-uploader-form {
  display: flex;
  flex-direction: column;

  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  .avatar-uploader {
    border: 1px dashed #8c939d;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .el-icon-plus {
      font-size: 20px;
    }

    .el-upload__text {
      line-height: 1;
    }
  }
}
</style>